export const xhrState = {
  data() {
    return {
      status: {
        ready: false,
        loading: false,
        error: false
      }
    }
  },
  created() {
    this.clearState()
  },
  computed: {
    isXhrLoading() {
      return this.status.loading
    },
    isXhrReady() {
      return this.status.ready
    },
    hasXhrError() {
      return this.status.error
    }
  },
  methods: {
    setErrorState() {
      this.status.loading = false
      this.status.ready = false
      this.status.error = true
    },
    setLoadingState() {
      this.status.loading = true
      this.status.ready = false
      this.status.error = false
    },
    setReadyState() {
      this.status.loading = false
      this.status.error = false
      this.status.ready = true
    },
    clearState() {
      this.status.loading = false
      this.status.ready = false
      this.status.error = false
    }
  }
}